/**
 *
 * @param value
 * @returns {string}
 */

export const generateValidFloatString = (value) => String(value).replace(/,/g, '.');
